<form>
  <section class="main-section">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a routerLink="/admin/sellerDashboard/">Home</a></li>
        <li class="breadcrumb-item active" aria-current="page">Reports</li>
      </ol>
    </nav>
    <div class="row">
      <div class="col">
        <div class="inner-box p-4">
          <h2>Reports</h2>
          <div class="row mt-4">
            <div class="col-md-6">
              <div class="report-box">
                <div class="row">
                  <div class="col-md-auto p-0">
                    <div class="icon-box" style="background-color: #96D1FE;">
                      <svg xmlns="http://www.w3.org/2000/svg" width="28" viewBox="0 0 16 16">
                        <path id="Icon_material-shopping-cart" data-name="Icon material-shopping-cart"
                              d="M6.3,15.8a1.6,1.6,0,1,0,1.6,1.6A1.6,1.6,0,0,0,6.3,15.8ZM1.5,3V4.6H3.1l2.88,6.072L4.9,12.632a1.547,1.547,0,0,0-.2.768A1.6,1.6,0,0,0,6.3,15h9.6V13.4H6.636a.2.2,0,0,1-.2-.2l.024-.1.72-1.3h5.96a1.592,1.592,0,0,0,1.4-.824L17.4,5.784a.782.782,0,0,0,.1-.384.8.8,0,0,0-.8-.8H4.868L4.116,3ZM14.3,15.8a1.6,1.6,0,1,0,1.6,1.6A1.6,1.6,0,0,0,14.3,15.8Z"
                              transform="translate(-1.5 -3)" fill="#fff"></path>
                      </svg>
                      Orders
                    </div>
                  </div>
                  <div class="col-md">
                    <div class="row">
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/sellerReportDetails"
                                [queryParams]="{type: 'Order Detail'}">Order Detail
                        </button>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</form>
